import React from 'react';
import useLogPage from '../useLogPage';
import LogFilters from '../LogFilters';
import LogTable from '../LogTable';
import LogStatCards from '../LogStatCards';
import { TrendChart, DonutChart } from '../LogCharts';
import { LogService } from '../../../services/activityLogService';

const STATUS_OPTIONS = [
  { value: 'sent',    label: 'Sent'    },
  { value: 'failed',  label: 'Failed'  },
  { value: 'pending', label: 'Pending' },
  { value: 'read',    label: 'Read'    },
];

const statusBadge = (v) => {
  const map = {
    sent:    ['#D1FAE5','#065F46'],
    failed:  ['#FEE2E2','#991B1B'],
    pending: ['#FEF3C7','#92400E'],
    read:    ['#DBEAFE','#1E40AF'],
  };
  const [bg, color] = map[v?.toLowerCase()] || ['#F3F4F6','#374151'];
  return <span className="al-badge" style={{ background: bg, color }}>{v || '—'}</span>;
};

const COLUMNS = [
  { key: 'id',         label: '#',       render: (v) => <span className="al-mono">{v}</span> },
  { key: 'user_id',    label: 'User ID', render: (v) => <span className="al-mono">{v || '—'}</span> },
  { key: 'type',       label: 'Type' },
  { key: 'title',      label: 'Title',   render: (v) => <span className="al-truncate" title={v}>{v || '—'}</span> },
  { key: 'message',    label: 'Message', render: (v) => <span className="al-truncate" title={v}>{v || '—'}</span> },
  { key: 'status',     label: 'Status',  render: statusBadge },
  { key: 'channel',    label: 'Channel' },
  { key: 'created_at', label: 'Time',    render: (v) => v ? new Date(v).toLocaleString('en-IN') : '—' },
];

const NotificationLog = () => {
  const lp = useLogPage(LogService.notifications);
  const s = lp.stats || {};

  const handleExport = () => {
    const { search, status, dateFrom, dateTo } = lp.filters;
    LogService.exportNotifications({
      ...(search   ? { search }              : {}),
      ...(status   ? { status }              : {}),
      ...(dateFrom ? { date_from: dateFrom } : {}),
      ...(dateTo   ? { date_to:   dateTo   } : {}),
      format: 'excel',
    });
  };

  const stats = [
    { label: 'Total Sent', value: lp.totalItems.toLocaleString(),       color: '#EC4899' },
    { label: 'Delivered',  value: (s.sent    ?? 0).toLocaleString(),    color: '#10B981' },
    { label: 'Failed',     value: (s.failed  ?? 0).toLocaleString(),    color: '#EF4444' },
    { label: 'Read',       value: (s.read    ?? 0).toLocaleString(),    color: '#3B82F6' },
  ];

  const donutData = lp.donut.length
    ? lp.donut
    : Object.entries(s.breakdown || {}).map(([name, value]) => ({ name, value }));

  return (
    <div className="al-page">
      <LogStatCards stats={stats} />

      <div className="al-charts">
        <TrendChart title="Notifications Over Time" data={lp.trend} color="#EC4899" />
        <DonutChart  title="Delivery Status"        data={donutData} />
      </div>

      <LogFilters
        filters={lp.filters}
        onFilterChange={lp.handleFilterChange}
        onApply={lp.handleApply}
        onReset={lp.handleReset}
        statusOptions={STATUS_OPTIONS}
        loading={lp.loading}
      />

      <LogTable
        title="Notification Logs"
        columns={COLUMNS}
        rows={lp.rows}
        loading={lp.loading}
        error={lp.error}
        page={lp.page}
        totalPages={lp.totalPages}
        totalItems={lp.totalItems}
        pageSize={lp.filters.pageSize}
        onPageChange={lp.handlePageChange}
        onExport={handleExport}
        onRefresh={lp.handleRefresh}
      />
    </div>
  );
};

export default NotificationLog;
